<template>
  <section class="auth">
    <slot></slot>
  </section>
</template>

<script>

export default {
  name: 'auth-layout'
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/auth-layout.vue